/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramFeedControllerGetFeedQueryResponse,
  TelegramFeedControllerGetFeedQueryParams,
  TelegramFeedControllerGetFeed401,
} from '../types/TelegramFeedControllerGetFeed.ts';

function getTelegramFeedGetFeedUrl() {
  const res = { method: 'GET', url: `/api/telegram/feed` as const };
  return res;
}

/**
 * {@link /api/telegram/feed}
 */
export async function telegramFeedGetFeed(
  params?: TelegramFeedControllerGetFeedQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramFeedControllerGetFeedQueryResponse,
    ResponseErrorConfig<TelegramFeedControllerGetFeed401>,
    unknown
  >({ method: 'GET', url: getTelegramFeedGetFeedUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
